import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { errorInterceptor, responseInterceptor } from 'config/http';
import { AppUser } from 'models/AppUser';
import { Logo } from 'models/Logo';
class AuthenticationService {
  protected http: AxiosInstance;

  constructor() {
    this.http = createHttpService();
  }

  public checkAuth() {
    return this.http
      .post('rpc/portal/profile-web/get')
      .then((response: AxiosResponse<AppUser>) => response.data);
  }

  public login(appUser: AppUser) {
    return this.http
      .post('rpc/portal/authentication/login', appUser)
      .then((response: AxiosResponse<AppUser>) => response.data);
  }

  public logout() {
    return this.http
      .post('rpc/portal/authentication/logout', {})
      .then((response: AxiosResponse<AppUser>) => response.data);
  }

  public refreshToken() {
    return this.http
      .post('rpc/portal/authentication/refresh-token', {})
      .then((response: AxiosResponse<number>) => response.data);
  }

  public forgotPassword = (email: string): Promise<AppUser> => {
    return this.http
      .post('rpc/portal/profile/forgot-password', { email })
      .then((response: AxiosResponse<AppUser>) => response.data);
  };

  public verifyOtpCode = (appUser): Promise<AppUser> => {
    return this.http
      .post('rpc/portal/profile/verify-otp-code', appUser)
      .then((response: AxiosResponse<AppUser>) => response.data);
  };

  public recoveryPassword = (password: string): Promise<AppUser> => {
    return this.http
      .post('rpc/portal/profile/recovery-password', { password })
      .then((response: AxiosResponse<AppUser>) => response.data);
  };

  public get = (): Promise<Logo> => {
    return this.http
      .post('rpc/portal/login-page/get')
      .then((response: AxiosResponse<Logo>) => response.data);
  };
  public updateProfile(profile: AppUser) {
    return this.http
      .post('rpc/portal/profile/update', profile)
      .then((response: AxiosResponse<AppUser>) => response.data);
  }
}

const createHttpService = () => {
  const instance: AxiosInstance = axios.create(httpConfig);
  instance.interceptors.response.use(responseInterceptor, errorInterceptor); // register fullfill and reject handler for http promise
  return instance;
};

const httpConfig: AxiosRequestConfig = {
  baseURL: window.location.origin,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};

export default new AuthenticationService();
